// Uniform contract for every question-type editor. The parent (QuestionEditor)
// owns the raw optionsJson / correctAnswerJson objects and the type-specific
// editor casts them to its own shape, mutates, and emits the next pair.
export interface QuestionTypeEditorProps {
  optionsJson: Record<string, unknown>;
  correctAnswerJson: Record<string, unknown>;
  onChange: (next: {
    optionsJson: Record<string, unknown>;
    correctAnswerJson: Record<string, unknown>;
  }) => void;
}

// A,B,C... keys derived from position so choice keys stay stable on reindex.
export const keyForIndex = (i: number): string => String.fromCharCode(65 + i);
